import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { DOCS_SEARCH_INDEX_URL } from './docsConstants'
import type { DocsSearchIndex } from './docsTypes'
import { searchDocs } from './docsSearchUtils'

async function fetchDocsSearchIndex(): Promise<DocsSearchIndex> {
  const response = await fetch(DOCS_SEARCH_INDEX_URL)
  if (!response.ok) {
    throw new Error('Failed to load documentation search index')
  }
  return response.json() as Promise<DocsSearchIndex>
}

export function useDocsSearch(query: string) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['docs-search-index'],
    queryFn: fetchDocsSearchIndex,
    staleTime: Infinity,
  })

  const results = useMemo(() => {
    if (!data?.docs) {
      return []
    }
    return searchDocs(data.docs, query)
  }, [data?.docs, query])

  return {
    results,
    isLoading,
    isError,
    hasIndex: Boolean(data?.docs),
  }
}
